<!-- Bouton de partage -->
<p-button icon="pi pi-share-alt" [rounded]="true" [text]="true" (click)="onClickShare($event)" [pTooltip]="tooltip"
    showDelay="1000" hideDelay="300"></p-button>

<!-- Repli : le navigateur a refusé la copie, le lien reste récupérable à la main -->
<p-popover #fallbackPopover appendTo="body">
    <div class="flex flex-column gap-2 w-25rem">
        <span class="font-medium">Votre navigateur a refusé la copie</span>
        <span class="text-color-secondary">Sélectionnez le lien ci-dessous et copiez-le à la main.</span>
        <input #fallbackInput pInputText type="text" class="w-full" [value]="shareUrl" readonly
            (click)="onClickLink($event)" />
    </div>
</p-popover>
